import { defineStore } from 'pinia';
import fileService from '@/api/fileService';

export const useFileStore = defineStore('file', {
  state: () => ({
    files: [],
    currentPage: 1,
    size: 10,
    totalFiles: 0,
    isLoading: false,
    searchResults: [],
  }),
  actions: {
    // Fetch all files for a project
    async fetchFilesByProjectId(projectId, page = 1, size = 10) {
      this.isLoading = true;
      try {
        const { data } = await fileService.getFilesByProjectId(projectId, page, size);
        const { items, total } = data;
        this.files = items;
        this.totalFiles = total;
        this.currentPage = page;
        this.size = size;
      } catch (error) {
        console.error('Error fetching files:', error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },

    // Upload a new file
    async uploadFile(fileData,projectId) {
      this.isLoading = true;
      try {
        const { data } = await fileService.uploadFile(fileData,projectId);
        this.files.push(data);
      } catch (error) {
        console.error('Error uploading file:', error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },

    // Search files for a project
    async searchFiles(projectId, query, page = 1, size = 10) {
      this.isLoading = true;
      try {
        const { data } = await fileService.searchFiles(projectId, query, page, size);
        this.searchResults = data.items;
        this.totalFiles = data.total;
        this.currentPage = page;
        this.size = size;
      } catch (error) {
        console.error('Error searching files:', error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },

    // Delete a file
    async deleteFile(fileId) {
      await fileService.deleteFile(fileId);
      this.files = this.files.filter(file => file.id !== fileId);
    }
  },
});
